export const partnerCategoryIcons = {
    1: 'industry',
    2: 'truck-fast',
    3: 'bullhorn',
    4: 'compass',
    5: 'shapes',
};

export const partnerCategoryDescriptionKeys = {
    1: 'ManufacturingDescription',
    2: 'FulfillmentDescription',
    3: 'MarketingDescription',
    4: 'AdvisoryDescription',
    5: 'OtherDescription',
};
